/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_Reactivation_WarningInputs */

const en_case_contact_reactivation_warning = /** @type {(inputs: Case_Contact_Reactivation_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An inactive contact with this phone number already exists in this case. Continuing will reactivate that contact and restore its conversation history.`)
};

const pt_br2_case_contact_reactivation_warning = /** @type {(inputs: Case_Contact_Reactivation_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe um contato inativo com este número de telefone neste caso. Ao continuar, esse contato será reativado e seu histórico de conversa será restaurado.`)
};

/**
* | output |
* | --- |
* | "An inactive contact with this phone number already exists in this case. Continuing will reactivate that contact and restore its conversation history." |
*
* @param {Case_Contact_Reactivation_WarningInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_reactivation_warning = /** @type {((inputs?: Case_Contact_Reactivation_WarningInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Reactivation_WarningInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_reactivation_warning(inputs)
	return pt_br2_case_contact_reactivation_warning(inputs)
});